
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const solis: Operator = {
	id: 'solis',
	name: 'Solis',
	role: 'Defender',
	org: 'AFEAU',
	squad: 'GHOSTEYES',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 3
	},
	meta: {
		gender: 'f',
		country: 'co',
		season: 'Y7S4',
		height: 166,
		weight: 65,
		price: {
			renown: 15000,
			r6credits: 360
		}
	},
	bio: {
		real_name: 'Ana Valentina Díaz',
		birthplace: 'Zipaquirå, Colombia'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="m36.9 37.5 86.7 65-11-30h9l9 9v-9h78.8l-4 32 23.9-32h10l-13 30 85.8-65-63.8 86 28.9-12v10l-16 18h16v68h-25.9l26.9 22v10l-30.9-14 64.8 86-85.8-64 13 30h-11l-17-15v15h-69.8l16-45-35.9 45h-10l13-30-87.7 64 65.8-85-29.9 13v-10l24.9-15H72.8v-72h27.9l-27.9-22v-10l30.9 14z" style="fill:#e7411f"></path><path d="M156.5 6.5h4l10 18v48l-17 18 17 16v10l5-4 5 4 13-13-14-13v-37l9-17h3l10 39 16 16v26l-10 9v5l5 4h18.9l11-11h34.9l17 18 49.9 13v4l-17.9 10h-48.9l-17-17-17 17h-11v10l14 14 13-14h38.9l16 8v3l-39.9 10-14 16h-26.9l-9-9-10 7v16l11 12v32l-18.9 20-12 48h-4l-10-18v-47l17.9-18-17.9-17v-10l-5 3-5-3-13 13 13 13v38l-8 17h-3l-10-40-15-14v-27l8-9v-6l-4-3h-19.9l-11 11H76.8l-19.9-19-48.9-13v-4l18.9-10h45.9l18.9 18 17-18h10v-8l-14-15-13 13H53.8l-15-7v-3l37.9-11 16-16h24.9l9 9 10-5v-18l-12-11v-32l18.9-20z" style="fill:#0e0e0e"></path><path d="m131.6 76.5 33.9 33v17l10-7 10 6v-6l16-16-16-16v-34l4-6 8 32 14 14v21l-9 8v12l9 7h22.9l12-12h27.9l-33.9 35h-13v18l18.9 18 16-16h33.9l6 5-30.9 7-14 15h-21.9l-20.9-22-38.9 23-32.9-19v-8l32.9 19 39.9-23v-29l-39.9-24-37.9 22-5-6 10-6v-22l-11-12v-28z" style="fill:#fff"></path><path d="M209.4 156.5v8l-33.9-20-40.9 23v30l40.9 23 37.9-22 6 6-10 6v23l11 11v29l-33.9-34v-16l-11 7-10-7v7l-16 15 16 16v33l-3 7-9-31-14-14v-22l9-9v-11l-9-6h-22.9l-11 11H76.8l33.9-34h14v-17l-19.9-20-16 16h-33l-7-4 29.9-8 15-13h21.9l20.9 20 38.9-23z" style="fill:#fff"></path><path d="m159.5 16.5 6 10v43l-11 12-19.9-9 14-13zm117.7 118 14 14 41.9 10-10 6h-42.9l-11-11zm-90.7 145 12-11 17 8-15 14-10 42-4-9zm-168.6-89 10-6h42.9l12 12-9 19-14-13zM173 154.2c-5.5 6.8-10.9 13.6-16.4 20.4l13.8 18.8c-9.8-6.3-19.6-12.5-29.5-18.8 10.8-6.7 21.4-13.6 32.1-20.4m8.9 1.9c9.2 6.2 18.4 12.4 27.6 18.5l-28.3 18.2 13-18.2-5.3-5.7-7 4.1z" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-solis'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
